module.exports = __webpack_public_path__ + "media/images/common/ico-star-off-db48aa045aa2b0943965d974914d5b67.svg";